import { Event } from '@guiker/event'
import { routesBuilder } from '@guiker/shared-framework'

import { Invoice } from '../../../../entity'
import { paths } from '../../paths'
import {
  addInvoiceItemPayloadSchema,
  cancelOneInvoicePayloadSchema,
  chargeInvoicePayloadSchema,
  verifyOneInvoicePayloadSchema,
} from '../schemas'

const basePath = paths.invoice.all.withId(':invoiceId')
const { buildPut, buildPost, buildGet, buildDelete } = routesBuilder<Invoice>()({ basePath })

export const routes = {
  readOneInvoice: buildGet({}),
  readLastInvoiceByScope: buildGet({
    path: paths.invoice.one.withScope(),
  }),
  sendDraftedInvoice: buildPut({
    path: '/send',
  }),
  refundOneInvoice: buildPost({
    path: '/refund',
  }),
  cancelOneInvoice: buildPut({
    path: '/cancel',
    payloadSchema: cancelOneInvoicePayloadSchema,
  }),
  chargeOneInvoiceOffline: buildPut({
    path: '/charge-offline',
  }),
  undoOfflineCharge: buildPut({
    path: '/undo-offline-charge',
  }),
  approveOfflineCharge: buildPut({
    path: '/approve-offline-charge',
  }),
  chargeInvoice: buildPost({
    path: '/charge',
    payloadSchema: chargeInvoicePayloadSchema,
  }),
  verifyOneInvoice: buildPut({
    path: '/verify',
    payloadSchema: verifyOneInvoicePayloadSchema,
    response: null as void,
  }),
  readAllEventByInvoiceId: buildGet({
    path: '/events',
    response: [] as Event<Invoice>[],
  }),
  addInvoiceItem: buildPost({
    path: '/items',
    payloadSchema: addInvoiceItemPayloadSchema,
  }),
  removeInvoiceItemById: buildDelete({
    path: '/items/:itemId',
  }),
} as const
